// import React from "react";
// import ReactECharts from "echarts-for-react";
// import { formatHoursToHm } from "../../../../../helpers/formatTime";

// const TimeReportChart = ({data , categorydata }) => {
//   const option = {
//     tooltip: {
//       trigger: "axis",
//       axisPointer: { type: "shadow" },
//       textStyle: {
//         fontFamily: "Nunito Sans, sans-serif",
//         fontSize: 12,
//         color: "#333",
//       },
//       formatter: (params) => {
//         const dataPoint = params[0];
//         return `
//           ${dataPoint.axisValue}<br/>
//           ${dataPoint.marker} ${dataPoint.seriesName}: ${formatHoursToHm(dataPoint.value)}
//         `;
//       },
//     },
//     grid: { left: "3%", right: "4%", bottom: "5%", containLabel: true },
//     xAxis: {
//       type: "category",
//       data: categorydata,
//       axisTick: { alignWithLabel: true },
//       axisLabel: {
//         fontFamily: "Nunito Sans, sans-serif",
//         fontSize: 12,
//         color: "#666",
//       },
//     },
//     yAxis: {
//       type: "value",
//       axisLabel: {
//         formatter: "{value} H",
//         fontFamily: "Nunito Sans, sans-serif",
//         fontSize: 12,
//         color: "#666",
//       },
//     },
//     series: [
//       {
//         name: "Duration",
//         type: "bar",
//         barWidth: "40%",
//         data: data, 
//         itemStyle: { color: "#6A5ACD" }, 
//         label: {
//           show: true,
//           position: "top",
//           fontFamily: "Nunito Sans, sans-serif",
//           fontSize: 12,
//           color: "#333",
//           formatter: (params) => formatHoursToHm(params.value),
//         },
//       },
//     ],
//   };

//   return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
// };

// export default TimeReportChart;


import React from "react";
import ReactECharts from "echarts-for-react";
import { formatHoursToHm } from "../../../../../helpers/formatTime";

const TimeReportChart = ({ data = [], categorydata = [] }) => {


  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      textStyle: {
        fontFamily: "Nunito Sans, sans-serif",
        fontSize: 12,
        color: "#333",
      },
      formatter: (params) => {
        const dataPoint = params[0];
        return `
          ${dataPoint.axisValue}<br/>
          ${dataPoint.marker} ${dataPoint.seriesName}: ${formatHoursToHm(dataPoint.value)}
        `;
      },
    },
    grid: { left: "3%", right: "4%", bottom: "5%", containLabel: true },
    xAxis: {
      type: "category",
      data: categorydata,
      axisTick: { alignWithLabel: true },
      axisLabel: {
        fontFamily: "Nunito Sans, sans-serif",
        fontSize: 12,
        color: "#666",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value) => formatHoursToHm(value),
        fontFamily: "Nunito Sans, sans-serif",
        fontSize: 12,
        color: "#666",
      },
    },
    series: [
      {
        name: "Duration",
        type: "bar",
        barWidth: "40%",
        data: data, // Convert hours to minutes
        itemStyle: { color: "#6A5ACD" },
        label: {
          show: true,
          position: "top",
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: 12,
          color: "#333",
          formatter: (params) => formatHoursToHm(params.value),
        },
      },
    ],
  };

  return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
};

export default TimeReportChart;